import { createSlice } from "@reduxjs/toolkit";
import reducers from "./reducer";
import { EmailAuth } from "./thunks";
import { RequestStatus as Status } from "constants/RequestStatus";
import { SessionStatus, SessionState } from "types/Session";

export const LOCAL_STORAGE_CREDENTIALS_KEY = "credentials";
export const LOCAL_STORAGE_USER_EMAIL = "username";

const initialState: SessionState = {
  credentials: {} || undefined,
  isAuthenticated: false,
  twoFAUpdateStatus: Status.Loading,
  isSessionConfirmed: false,
  status: SessionStatus.initial,
  embedToken: "",
  otpAuthUrl: "" || null,
  twoFactorAuthEnabled: false,
  twoFactorValidated: Status.Idle,
  loginRequestStatus: Status.Idle,
};

export const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers,
});

export const getSavedCredentials = (): any => {
  let credentials;
  try {
    // Try to get from localstorage
    const localCredentials = localStorage.getItem(
      LOCAL_STORAGE_CREDENTIALS_KEY
    );
    if (localCredentials) {
      credentials = JSON.parse(localCredentials);
    }
  } catch (err) {
    console.error("Error getting credentials:", err);
  }

  return credentials;
};

export const getUserEmail = (): Partial<EmailAuth> | undefined => {
  let email: Partial<EmailAuth> | undefined;
  try {
    // Try to get from localstorage
    const localUsername = localStorage.getItem(LOCAL_STORAGE_USER_EMAIL);
    if (localUsername) {
      email = JSON.parse(localUsername);
    }
  } catch (err) {
    console.error("Error getting email:", err);
  }

  return email;
};

export const setSavedUsername = (email: string): void => {
  const userEmail = { email };
  localStorage.setItem(LOCAL_STORAGE_USER_EMAIL, JSON.stringify(userEmail));
};

export const clearSavedUsername = (): void => {
  localStorage.removeItem(LOCAL_STORAGE_USER_EMAIL);
};

export const setSavedCredentials = (credentials: any): void => {
  localStorage.setItem(
    LOCAL_STORAGE_CREDENTIALS_KEY,
    JSON.stringify(credentials)
  );
};
export const clearSavedCredentials = (): void => {
  localStorage.removeItem(LOCAL_STORAGE_CREDENTIALS_KEY);
};

export const {
  setCredentials,
  setTwoFAUpdateStatus,
  updateIsAuthenticated,
  updateSessionStatus,
  logOut,
  confirmSession,
  setEmbedToken,
  setOtpAuthUrl,
  setTwoFactorAuthEnabled,
  setTwoFactorValidated,
  setLoginRequestStatus,
} = sessionSlice.actions;

export default sessionSlice.reducer;
